<template>
 <pop-up-layout 
   :mini="true"
   :title="$t('reservaSimplificada.preguntaTitulo')"
   :description="$t('reservaSimplificada.preguntaInicioProceso')"
   :aceptar="$t('reservaSimplificada.aceptar')"
   :disabled="!valid"
   :saving="waitingForLoad"
   @volver="$parent.hide()"
   @aceptar="aceptar()"
 >
   <v-form v-model="valid">
     <v-layout mb-3 justify-center>
      <v-radio-group v-model="tipoReserva" row style="justify-content:center" :rules="[rules.obligatorio]">
      <v-radio :label="$t(opciones[0].text)" :value="opciones[0].value" ></v-radio>
      <v-radio :label="$t(opciones[1].text)" :value="opciones[1].value"></v-radio>
     </v-radio-group>
     </v-layout>
   </v-form>
 </pop-up-layout>
</template>

<script>
import rulesMixin from '@/mixins/rules.js'
import { mapActions } from 'vuex'
export default {
 mixins: [rulesMixin],
 props: ['alquiler'],
 data () {
   return {
     tipoReserva: null,
     opciones: [
      {
       value: 'extendida',
       text: this.alquiler ? 'reservaSimplificada.alquilerextentido' : 'reservaSimplificada.ventaextendida'
      },
      {
       value: 'simplificada',
       text: this.alquiler ? 'reservaSimplificada.alguilersimplificado' : 'reservaSimplificada.ventasimplificada'
      }
     ],
     valid: false,
     waitingForLoad: false
   }
 },
 created () {
   this.usermail = this.usermailProp
 },
 methods: {
   ...mapActions({
     addAlert: 'alerts/add'
   }),
   aceptar () {
     this.$emit('tipoReserva', this.tipoReserva)
     this.$parent.hide()
   }
 }
}
</script>


// WEBPACK FOOTER //
// src/components/incrustado/PopUpPreguntaSimplificada.vue